import React from 'react';

import Alert from 'bs/Alert';
import Markdown from 'utils/markdown';

import { getEnv } from 'utils/env';

const SiteNotice = props => {
    const notice = getEnv('REACT_APP_SITE_NOTICE', '');

    if (notice) {
        return (
            <Alert flavor='warning' {...props}>
                <Markdown>{notice}</Markdown>
            </Alert>
        );
    } else {
        return null;
    }
};

export default SiteNotice;
